import type { OpenApiFetchClient } from './types';
import { createTopApi } from './top';
import { createMedicalInstitutionsApi } from './medicalInstitutions';

export function createApiRepository(client: OpenApiFetchClient) {
  return {
    topApi: createTopApi(client),
    medicalInstitutionsApi: createMedicalInstitutionsApi(client),
  };
}

export type ApiClient = ReturnType<typeof createApiRepository>;
